module.exports = __webpack_public_path__ + "img/smiley-green.cb3ed265.svg";